/**
 * lottie-web Safari 分支会对 SVG <image> 调 getBBox 探测加载完成。
 * iOS WebKit 上该节点经常没有 getBBox，抛 TypeError。
 * width 不能为 0，否则探测会空转 25s。
 */
function emptyBBox() {
  return {
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    top: 0,
    right: 1,
    bottom: 1,
    left: 0
  };
}

function patchGetBBox(Ctor) {
  if (!Ctor || !Ctor.prototype) return;
  if (typeof Ctor.prototype.getBBox !== 'function') {
    Ctor.prototype.getBBox = emptyBBox;
  }
}

patchGetBBox(window.SVGElement);
patchGetBBox(window.SVGGraphicsElement);
patchGetBBox(window.SVGSVGElement);
patchGetBBox(window.SVGImageElement);
